import { ShipmentTemplateWithTags } from '~api/userprofile';

import { NavLink } from 'react-router-dom';

import { Add16 } from '@ingrid/iconography/react';
import { Button, Modal, ModalSelect, SearchInput, SimpleOptionList, Spinner } from '@ingrid/luterkort-react';

import { SelectModal, SelectModalProps } from '~src/components/Modal/Modal';
import { useTranslation } from '~src/i18n/use-translation';
import { useSiteId } from '~src/main/hooks/useSiteId';
import { AppRoute } from '~src/main/routes';
import { useShipmentTemplatesList } from '~src/pages/settings/shipment-template/queries';

export type TemplateSelectProps = {
  value?: ShipmentTemplateWithTags;
  onValueChange: (v?: ShipmentTemplateWithTags) => void;
} & Pick<SelectModalProps, 'trigger'>;

export function TemplateSelect({ value, onValueChange, ...modalProps }: TemplateSelectProps) {
  const siteId = useSiteId();

  const { data: templates = [], isLoading } = useShipmentTemplatesList();
  const { t } = useTranslation();

  return (
    <SelectModal
      onValueChange={v => onValueChange(templates.find(t => t.template?.id === v[0]))}
      value={value?.template?.id ? [value.template.id] : ['']}
      filterFactory={search =>
        ({ searchContext: context }) =>
          search ? !!context[1]?.toLocaleLowerCase().includes(search) : true
        }
      {...modalProps}
    >
      <Modal.Header title={t('shipments.template.selectTemplate')} />

      <ModalSelect.Content>
        <ModalSelect.Control>
          <SearchInput placeholder={t('shipments.template.searchTemplate')} name="search" />
        </ModalSelect.Control>

        {!isLoading ? (
          <SimpleOptionList
            options={templates.map(({ template }) => [template?.id, template?.data?.name] as [string, string])}
          />
        ) : (
          <Spinner />
        )}
      </ModalSelect.Content>

      <Modal.Footer style={{ justifyContent: 'flex-start' }}>
        <Button
          to={`/${AppRoute.SITE}/${siteId}/${AppRoute.SETTINGS}/${AppRoute.SHIPMENT_TEMPLATES}/${AppRoute.CREATE}`}
          variant="quaternary"
          as={NavLink}
        >
          <Add16 /> {t('shipments.template.createNew')}
        </Button>
      </Modal.Footer>
    </SelectModal>
  );
}
